/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/device_profile';
import '../model/shared/device_profile_link';
import '../model/shared/device_profile';
import './status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "UpdateDeviceProfileV2Request": {
                        "fields": {
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfileLink": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          },
                          "autoRenameOnDuplicate": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "UpdateDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.UpdateDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.UpdateDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/update_device_profile.proto at 14:1
 */
export const UpdateDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.UpdateDeviceProfileV2Request');
fixType(UpdateDeviceProfileV2Request, {
  profile: {
    required: true
  },
  deviceProfile: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateDeviceProfileV2Request);
/**
 * SOURCE UpdateDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/update_device_profile.proto at 22:1
 */
export const UpdateDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.UpdateDeviceProfileV2Response');
fixType(UpdateDeviceProfileV2Response);
Builder.createAndAttachToType(UpdateDeviceProfileV2Response);